import { useTranslation } from '@e-kyc/translations';
import { useForm } from 'react-hook-form';

import { Button, Form } from '../../../components';
import { useEkyc } from '../../../providers';

interface AcceptPrivacyNoticeInput {
  accept: boolean;
}

interface TermsFooterProps {
  isScrolledToBottom: boolean;
}

export default function TermsFooter(props: TermsFooterProps) {
  const { isScrolledToBottom } = props;
  const { control, watch, setValue } = useForm<AcceptPrivacyNoticeInput>({
    defaultValues: {
      accept: false,
    },
  });
  const { accept } = watch();
  const { t } = useTranslation();
  const { setStep } = useEkyc();

  const handleOnSubmit = () => {
    // TODO: integrate with API
    setStep('capture-card-consent');
  };

  const handleOnBackButtonClick = () => {
    setStep('onboarding');
  };
  const handleOnCheckboxChange = () => {
    setValue('accept', !accept);
  };

  return (
    <div className='fixed bottom-0 z-100 mx-auto h-fit w-full max-w-md border-t-1 border-gray-300 bg-white'>
      <div className='w-full p-4'>
        <Form.Checkbox
          name='accept'
          control={control}
          required
          checked={accept}
          onChange={handleOnCheckboxChange}
          disabled={!isScrolledToBottom}
        >
          {t('termsAndConditions.checkbox')}
        </Form.Checkbox>
      </div>
      <div className='flex h-fit w-full gap-4 px-4 pt-4 pb-8'>
        <Button variant='outlined' fullWidth onClick={handleOnBackButtonClick}>
          {t('button.back')}
        </Button>
        <Button fullWidth onClick={handleOnSubmit} disabled={!accept}>
          {t('button.accept')}
        </Button>
      </div>
    </div>
  );
}
